import styled from 'styled-components';

export const StyledCarCondition = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px 24px;
    background-color: #f7f7f8;
    margin-top: 20px;
`;

export const StyledHeader = styled.p`
    color: #0b0b0b;
    font-size: 25px;
    font-weight: bold;
    font-family: 'Corporate E';
    margin-bottom: 14px;
`;

export const StyledDescription = styled.div`
    white-space: pre-line;
    font-size: 14px;
    line-height: 23px;
`;
